import React from 'react';
import { colors } from '../theme';
import IProps from './interface';

const CallHangupIcon = ({
  color = colors.white,
  size = 24,
  ...props
}: IProps) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18.434 16.8531H20C21.105 16.8531 22 15.956 22 14.8485V13.8321C22 12.8007 21.472 11.8415 20.598 11.2431C18.441 9.76865 15.401 8.83447 12 8.83447C8.599 8.83447 5.559 9.76865 3.402 11.2441C2.528 11.8425 2 12.8017 2 13.8321V14.8485C2 15.956 2.895 16.8531 4 16.8531H5.566C6.394 16.8531 7.066 16.1796 7.066 15.3496V13.9834C7.066 13.6757 7.247 13.3911 7.533 13.2798C8.859 12.7646 10.379 12.4679 12 12.4679C13.621 12.4679 15.141 12.7646 16.467 13.2798C16.753 13.3911 16.934 13.6757 16.934 13.9834V15.3496C16.934 16.1796 17.606 16.8531 18.434 16.8531V16.8531Z"
        stroke={color}
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default CallHangupIcon;
